import React from 'react';
import { Users } from 'lucide-react';

// Practice → practitioner breakdown (gap 3.2). A one-glance strip of each
// provider's load with a needs-attention count; clicking drills the worklist
// down to that practitioner. `items` should be scoped by every filter EXCEPT
// provider, so the counts reflect the full per-provider picture.
export default function PractitionerBreakdown({ providers, items, selected, onSelect }) {
  const stats = providers
    .map((p) => {
      const rows = items.filter((i) => i.apt.providerId === p.id);
      return {
        id: p.id,
        name: `Dr. ${p.lastName}`,
        total: rows.length,
        attention: rows.filter((i) => i.agentState === 'awaiting_review' || i.agentState === 'flagged').length,
      };
    })
    .filter((s) => s.total > 0);

  if (stats.length <= 1) return null;

  const chip = (active) =>
    `inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-medium transition-colors ${
      active ? 'border-brand-300 bg-brand-50 text-brand-700' : 'border-slate-200 bg-white text-slate-600 hover:text-slate-900'
    }`;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-slate-400 inline-flex items-center gap-1.5 mr-0.5"><Users className="h-3.5 w-3.5" />By practitioner</span>
      <button onClick={() => onSelect('all')} className={chip(selected === 'all')}>All</button>
      {stats.map((s) => (
        <button key={s.id} onClick={() => onSelect(selected === s.id ? 'all' : s.id)} className={chip(selected === s.id)}>
          {s.name}
          <span className="tnum text-slate-400">{s.total}</span>
          {s.attention > 0 && <span className="pill pill-amber text-[10px] !px-1.5">{s.attention}</span>}
        </button>
      ))}
    </div>
  );
}
